// extracted by mini-css-extract-plugin
export default {"icon":"quiz-icons_icon__idlIg"};